module.exports = "https://cdn2-fs.clearscore.com/flux/images/aa52558e5d121f0b6ca1291c1d93ff17.jpg";